import { BusinessApi } from 'shared/api';
import { ICreateBusinessDto } from 'shared/api/business/interfaces/create-business-dto.interface';

export const createBusiness = async (
  requestData: ICreateBusinessDto
): Promise<string> => {
  const response: any = await BusinessApi.createBusiness(requestData);
  const data = response.data;
  if (data == null) return '';
  if (typeof data === 'string') return data;
  if (typeof data === 'number') return String(data);
  const id = data.id ?? data.businessId ?? '';
  return typeof id === 'string' ? id : String(id);
};
